import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { beginIdv, completeIdv } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { BeginIdvPayload, BeginIdvResponse, CompleteIdvPayload, CompleteIdvResponse } from "./types";

interface BeginIdvParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: BeginIdvPayload;
}

export const useBeginIdv = (
  options?: UseMutationOptions<BeginIdvResponse, Error, BeginIdvParams>
) => {
  return useMutation<BeginIdvResponse, Error, BeginIdvParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      beginIdv(userId, applicationId, providerType, payload),
    ...options,
  });
};

interface CompleteIdvParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: CompleteIdvPayload;
}

export const useCompleteIdv = (
  options?: UseMutationOptions<CompleteIdvResponse, Error, CompleteIdvParams>
) => {
  return useMutation<CompleteIdvResponse, Error, CompleteIdvParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      completeIdv(userId, applicationId, providerType, payload),
    ...options,
  });
};
